module.exports = __webpack_public_path__ + "static/media/customer-support-bg.b98a83ef.png";